import Component from "../../lib/component";
import {filterInventoryItems} from "./inventory_items_filter";
import {getDebouncedFunction} from "../../helpers/debounce";

export const InventoryFilterConfig = {
    componentTypeKey: 'Inventory',
    baseHtmlClass: 'inventory__head__filter',
    selector: '.inventory__head__filter',

    defaultPlaceholder: 'Search',
};

export class InventoryFilter extends Component {

    static createElement(inventory) {
        let element = document.createElement('div');
        element.classList.add(InventoryFilterConfig.baseHtmlClass);
        let formElement = createFormElement();
        let inputElement = createInputElement(inventory)
        formElement.append(inputElement);
        element.append(formElement);
        return element;
    }

    constructor(id_or_element, inventory) {
        super({
            element: id_or_element,
            config: InventoryFilterConfig
        });

        this.inventory = inventory;

        this.formElement = this.element.querySelector('form');
        this.formElement.addEventListener('submit', (event) => {
            event.preventDefault();
            return false;
        });

        this.inputElement = this.element.querySelector('input');
        const keyInputHandler = getDebouncedFunction(this.handleKeyInput.bind(this), 400);
        this.inputElement.addEventListener('keyup', keyInputHandler);
    }

    handleKeyInput() {
        let searchStr = (this.inputElement) ? this.inputElement.value : '';
        filterInventoryItems(this.inventory.items, searchStr);
        this.inventory.render();
    }
}

function createInputElement(inventory) {
    let element = document.createElement('input');
    element.type = "text";
    element.placeholder = inventory?.filterPlaceholder || InventoryFilterConfig.defaultPlaceholder;
    return element;
}

function createFormElement() {
    let element = document.createElement('form');
    return element;
}

